import React from 'react';
import { CasesCarousel } from '../../molecules';
import { useFeaturedCases } from '../../../hooks/useFeaturedCases';
import styles from './CasesSection.module.css';
import { useCursor } from '@/contexts/CursorContext';

interface CasesSectionProps {
  className?: string;
}

const translations = {
  moreCases: {
    en: 'More cases',
    fr: 'Plus de projets',
  },
};

export const CasesSection: React.FC<CasesSectionProps> = ({ className }) => {
  const { cases, loading, error, refetch } = useFeaturedCases();

  const { setState } = useCursor();

  const onMouseEnter = () => {
    setState('link');
  };

  const onMouseLeave = () => {
    setState('default');
  };

  if (loading) {
    return null;
  }

  if (error) {
    return (
      <section className={`${styles.casesSection} ${className || ''}`}>
        <div className={styles.errorState}>
          <h3>Unable to load cases</h3>
          <p>{error}</p>
          <button
            onClick={refetch}
            className={styles.retryButton}
            aria-label="Retry loading cases"
          >
            Try Again
          </button>
        </div>
      </section>
    );
  }

  if (cases.length === 0) {
    return (
      <section className={`${styles.casesSection} ${className || ''}`}>
        <div className={styles.emptyState}>
          <p>No cases available at the moment.</p>
        </div>
      </section>
    );
  }

  return (
    <section className={`${styles.casesSection} ${className || ''}`}>
      <div className={styles.carouselContainer}>
        <CasesCarousel cases={cases} />
      </div>
      <div className={styles.ctaViewMoreWrapper}>
        <a
          href="/cases"
          className={`${styles.actionUnderline}`}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <span className={styles.line}>
            {navigator.language?.includes('fr')
              ? translations.moreCases.fr
              : translations.moreCases.en}
          </span>
        </a>
      </div>
    </section>
  );
};
